import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useTranslation } from 'react-i18next';
import { useGetBillingQuery } from 'services/payments/api';
import envvars from 'utils/envvars';
import CheckoutForm from './payments/CheckoutForm';
import styles from './SettingsBilling.module.css';

const stripePromise = loadStripe(envvars.stripePublishKey);

const options = {
  amount: 199,
  currency: 'usd',
  mode: 'subscription' as const,
  appearance: {
    /*...*/
  },
};

const formatUsd = (amountCents: number, language: string) => (
  new Intl.NumberFormat(language, {
    currency: 'USD',
    style: 'currency',
  }).format(amountCents / 100)
);

const SettingsBilling = () => {
  const { i18n, t } = useTranslation();
  const { data: billing, isLoading } = useGetBillingQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const chargesSoFar = billing?.chargesSoFar;
  const monthEstimate = billing?.monthEstimate;

  return (
    <>
      <div className={styles.estimate}>
        <p className={styles.label}>{t('billingChargesSoFar')}</p>
        <p className={styles.amount}>
          {isLoading ? '\u2026' : chargesSoFar && formatUsd(chargesSoFar.amountCents, i18n.language)}
        </p>
        <p className={styles.detail}>{t('billingChargesSoFarDetail')}</p>
      </div>
      <div className={styles.estimate}>
        <p className={styles.label}>{t('billingMonthEstimate')}</p>
        <p className={styles.amount}>
          {isLoading ? '\u2026' : monthEstimate && formatUsd(monthEstimate.amountCents, i18n.language)}
        </p>
        <p className={styles.detail}>{t('billingMonthEstimateDetail')}</p>
      </div>
      <Elements
        options={options}
        stripe={stripePromise}
      >
        <CheckoutForm />
      </Elements>
    </>
  );
};

export default SettingsBilling;
